import { render } from "./ReportsCatalogue.vue?vue&type=template&id=591b4dfc&scoped=true"
import script from "./ReportsCatalogue.vue?vue&type=script&lang=js"
export * from "./ReportsCatalogue.vue?vue&type=script&lang=js"

import "./ReportsCatalogue.vue?vue&type=style&index=0&id=591b4dfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591b4dfc"]])

export default __exports__